<template>
  <div class="disclaimer-container" v-if="isShow">
    <button class="close-button" @click="confirmDisclaimer">
      <svg
        width="10"
        height="10"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 1L19 19M19 1L1 19"
          stroke="#666"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
    <div>
      This service is provided by our partners. The search information will be
      forwarded to them for service fulfillment.
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: true,
    };
  },
  mounted() {
    // remove if statement to use localstorage
    if (false) this.checkDisclaimer();
  },
  methods: {
    checkDisclaimer() {
      const disclaimer = localStorage.getItem("disclaimer");
      if (disclaimer == "true") {
        this.isShow = false;
      }
    },
    confirmDisclaimer() {
      localStorage.setItem("disclaimer", true);
      this.isShow = false;
      console.log("confirmDisclaimer", this.isShow);
    },
  },
};
</script>

<style scoped>
.disclaimer-container {
  position: fixed;
  bottom: 10px;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 10px;
  border: 1px solid #ccc;
  left: 50%;
  transform: translateX(-50%);
  max-width: 100%;
  width: 320px;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  font-size: 14px;
  color: #666;
  z-index: 999999;
}

.close-button {
  position: absolute;
  top: 0;
  right: 0;
  padding: 6px 8px;
  outline: none;
  border: none;
  background-color: transparent;
  cursor: pointer;
}
</style>
